<template>
  <div class="wrap-why">
    <div class="page-help content">
      <div class="up">
        <div class="title">
          {{ $t("newHome.whyEberza") }}
        </div>
        <!-- <div class="posts">
          <div class="txt">{{ $t("newHome.MoreThan2000Posts") }}</div>
          <div class="images">
            <img src="" alt="" />
          </div>
        </div> -->
      </div>
      <div class="bottom">
        <div class="left">
          <div
            v-for="(link, index) in links"
            :key="index"
            @click="setLink(index)"
            class="page"
            :class="{ active: selectedLink === index }"
          >
            {{ $t(link.title) }}
          </div>
        </div>
        <div class="right">
          <div
            class="link-content animate-in"
            v-if="selectedLink || selectedLink === 0"
          >
            <div class="link-txt">{{ $t(links[selectedLink].text) }}</div>
            <router-link
              class="ordinary-link"
              :to="{
                name: links[selectedLink].link,
                params: { lang: $i18n.locale }
              }"
            >
              {{ $t("newHome.findMore") }}</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      links: [
        {
          title: "newHome.forBuyer",
          id: "01",
          text: "newHome.forBuyerTxt",
          link: "Buyers"
        },
        {
          title: "newHome.forSellers",
          id: "02",
          text: "newHome.forSellersTxt",
          link: "Sellers"
        },
        {
          title: "newHome.forFranchise",
          id: "03",
          text: "newHome.forFranchiseTxt",
          link: "Franchise"
        }
      ],
      selectedLink: 0
    };
  },
  methods: {
    setLink(index) {
      this.selectedLink = null;
      setTimeout(() => {
        this.selectedLink = index;
      }, 100);
    }
  }
};
</script>
<style lang="scss" scoped>
@keyframes fadeSlide {
  0% {
    opacity: 0;
    transform: translateX(40%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-in {
  animation: fadeSlide 0.5s ease;
}
.wrap-why {
  font-family: Outfit;
  width: 100%;
  padding-top: 96px;
  text-align: left;
  background-color: $gray-blue-400;
  .content {
    .up {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid $gray-blue-1200;
      margin-bottom: 56px;
      .title {
        font-weight: 500;
        font-style: Medium;
        font-size: 64px;
        line-height: 100%;
        letter-spacing: 0%;
      }
      .posts {
        width: 733px;
        .txt {
          font-weight: 500;
          font-style: Medium;
          font-size: 24px;
          line-height: 100%;
          letter-spacing: 0%;
        }
        .images {
          width: auto;
        }
      }
    }
    .bottom {
      height: fit-content;
      display: flex;
      justify-content: space-between;
      padding-bottom: 95px;
      .left {
        max-width: 504px;
        .page {
          cursor: pointer;
          font-weight: 500;
          font-style: Medium;
          font-size: 36px;
          line-height: 100%;
          letter-spacing: 0%;
          color: $blue-400;
          margin-bottom: 15px;
        }
        .page:last-of-type {
          margin-bottom: 0;
        }
        .page.active {
          color: $blue-1000;
        }
      }
      .right {
        width: 733px;
        overflow: hidden;
        .link-content {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .no {
            color: $blue-1000;
            font-weight: 500;
            font-style: Medium;
            font-size: 22px;
            line-height: 100%;
            letter-spacing: 0%;
          }
          .link-txt {
            color: $blue-400;
            font-weight: 500;
            font-style: Medium;
            font-size: 20px;
            line-height: 30px;
            letter-spacing: 0%;
          }
          .ordinary-link {
            color: $blue-1000;
            font-weight: 400;
            font-style: Regular;
            font-size: 20px;
            line-height: 100%;
            letter-spacing: 0%;
            text-decoration: underline;
            text-decoration-style: solid;
            text-decoration-offset: 0%;
            text-decoration-thickness: 0%;
            text-decoration-skip-ink: auto;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
  .wrap-why {
    padding-top: 66px;

    .content {
      .up {
        display: flex;
        flex-wrap: wrap;

        margin-bottom: 36px;
        .title {
          font-size: 34px;
          margin-right: 5px;
          margin-bottom: 20px;
        }
        .posts {
          width: 733px;
          .txt {
            font-size: 24px;
          }
          .images {
            width: auto;
          }
        }
      }
      .bottom {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 55px;
        .left {
          max-width: 504px;
          margin-right: 19px;
          margin-bottom: 20px;
          .page {
            font-size: 36px;
            margin-bottom: 10px;
          }
          .page:last-of-type {
            margin-bottom: 0;
          }
        }
        .right {
          width: 733px;
          min-height: 128px;
          overflow: hidden;
          margin-bottom: 20px;
          .link-content {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .no {
              color: $blue-1000;
              font-weight: 500;
              font-style: Medium;
              font-size: 22px;
              line-height: 100%;
              letter-spacing: 0%;
            }
            .link-txt {
              color: $blue-400;
              font-weight: 500;
              font-style: Medium;
              font-size: 20px;
              line-height: 30px;
              letter-spacing: 0%;
            }
            .ordinary-link {
              color: $blue-1000;
              font-weight: 400;
              font-style: Regular;
              font-size: 20px;
              line-height: 100%;
              letter-spacing: 0%;
              text-decoration: underline;
              text-decoration-style: solid;
              text-decoration-offset: 0%;
              text-decoration-thickness: 0%;
              text-decoration-skip-ink: auto;
            }
          }
        }
      }
    }
  }
}
</style>
